module.exports = __webpack_public_path__ + "img/thumb-up.7eeebd26.png";